import { render, staticRenderFns } from "./CollectionFilterOperatorMenu.vue?vue&type=template&id=0be6f158"
import script from "./CollectionFilterOperatorMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionFilterOperatorMenu.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports